<template>
  <el-dialog 
    :visible.sync="dialogVisible" 
    append-to-body
    width="360px"
    :show-close="false"
    title="Find Password"
    custom-class="login-form-dialog">
    <template>
      <el-form ref="loginForm" :model="loginData">
        <el-form-item label="E-mail">
          <el-input 
            v-model="loginData.e_mail" 
            placeholder="Please input E-mail"
            maxlength="50"
            @keyup.native.enter="doSubmit"/>
        </el-form-item>
        <el-form-item prop="password" label="ACSL ID">
          <el-input
            v-model="loginData.acsl_id"
            placeholder="Please input ACSL ID"
            maxlength="20"
            @keyup.native.enter="doSubmit"/>
        </el-form-item>
        <el-form-item prop="password_rep" label="New Password">
          <el-input
            v-model="loginData.password"
            placeholder="Please input new password"
            type="password"
            maxlength="20"
            @keyup.native.enter="doSubmit"/>
        </el-form-item>
        <div class="btn-wrap">
          <el-button type="primary" style="width: 100%;" @click="doSubmit" class="login-btn">Submit</el-button>
        </div>
      </el-form>
    </template>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import confirm from '@/mixins/confirm'

export default {
  mixins: [confirm],
  data() {
    return {
      dialogVisible: false,
      loginData: {
        e_mail: '',
        acsl_id: '',
        password: '',
      },
    }
  },
  methods: {
    ...mapActions({
      actionUserFindPassword: 'userFindPassword',
    }),
    async show() {
      this.dialogVisible = true
    },
    async doSubmit() {
      try {
        const { e_mail, acsl_id, password } = this.loginData;
        if (!e_mail || !acsl_id || !password) {
          throw new Error('Pleace complete form');
        }
        this.loading = true
        const ret = await this.actionUserFindPassword({
          e_mail,
          acsl_id,
          password,
        })
        this.loading = false
        if (ret.code === 0) {
          this.$message.success('Save successful');
          setTimeout(() => {
            this.logOut()
          }, 1000);
        }
      } catch (e) {
        this.$message.warning(e.message);
      }
    },
    async logOut() {
      if (this.$route.name != 'home') {
        this.$router.push('/home');
      } else {
        window.location.reload()
      }
    }
  }
}
</script>
<style lang="less">
.login-form-dialog {
  border-radius: 12px;
  .el-dialog__body {
    padding-top: 0;
  }
}
</style>
<style lang="less" scoped>
.logo-wrap {
  width: 100%;
  display: flex;
  justify-content: center;
  img {
    width: 64px;
  }
}
.login-type-wrap {
  padding: 32px 0 64px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  justify-content: center;
}
.btn-wrap {
  margin-top: 30px;
  display: flex;
  align-items: center;
  flex-direction: column;
  .back-link {
    margin: 16px auto 0;
  }
}
  .login-btn {
    background: @themeColor1;
    border: none;
    border-radius: 40px;
    margin: 0;
    &:active {
      opacity: .8;
    }
    &:hover {
      opacity: .9;
    }
  }
</style>
